import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import { Md5 } from 'ts-md5/dist/md5';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface KennzahlenRohProps {
}

export interface KennzahlenRohState {
    errors: number;
    filterError: boolean;
}

export class KennzahlenRoh extends React.Component<KennzahlenRohProps, KennzahlenRohState> {
    constructor(props: any) {
        super(props);
        this.state = {
            errors: 0,
            filterError: false
        };
        this.customFormatter = this.customFormatter.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.preFilter = this.preFilter.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    private rows: any = {};

    customFormatter(field: string, value: any, data: any): any {
        const status: any = this.rows[data.tid] || {};
        let backgroundColor: string = null;
        let color: string = null;

        if (status.type === 'error') {
            backgroundColor = '#edb6ab';
            color = '#bf4329';
        } else {
            return value;
        }

        return (
            <div style={{ color, backgroundColor, height: '100%', outline: `2px solid ${backgroundColor}` }}>
                {value}
            </div>
        );
    }

    onDataLoaded(data: any[]): void {
        const hashes: any = {};
        let errors: number = 0;

        (data || []).forEach((item: any) => {
            const compare: any = { ...item };
            const tid: number = item.tid || null;
            const values: any = {};
            delete compare.tid;
            const hash: string = Md5.hashAsciiStr(JSON.stringify(compare)).toString();

            if (hashes[hash]) {
                values.type = 'error';
                ++errors;
            }
            hashes[hash] = true;
            this.rows[tid] = values;
        });
        this.setState({ errors });
    }

    preFilter(data: any[]): any[] {
        return data.filter((item: any) => !this.state.filterError || (this.rows[item.tid] || {}).type === 'error');
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                key={`${IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL}_${this.state.filterError}`}
                entity={IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                externalHeaderElements={[this.renderFilterErrorButton()]}
                customClass='Custom-ETA'
                formLayout='flowV2'
                customFormatter={this.customFormatter}
                preFilterFunction={this.preFilter}
                onDataLoaded={this.onDataLoaded}
                onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL)}
                showColumnsHelp
            />
        );
    }

    renderFilterErrorButton(): JSX.Element {
        if (!this.state.errors) {
            return null;
        }

        return (
            <label
                style={{
                    fontSize: 12, color: '#bf4329', backgroundColor: '#edb6ab', height: 28, marginTop: 2, marginRight: 2, padding: '0 3px',
                    display: 'flex', alignItems: 'center', cursor: 'pointer'
                }}
            >
                <input
                    type='checkbox'
                    checked={this.state.filterError}
                    onChange={(event: any) => this.setState({ filterError: event.target.checked })}
                />
                {`Duplikate (${this.state.errors})`}
            </label>
        );
    }
}
